import { Element } from 'slate';
import { ReactEditor } from 'slate-react';
import type { SlateEditor } from 'platejs';

import { asEditor } from 'common/components/ContentEditor/utils/editorHelpers';
import { BlockMenuEmbed } from 'common/components/ContentEditor/elements/embed/BlockMenuEmbed';
import { BlockMenuFile } from 'common/components/ContentEditor/elements/file/BlockMenuFile';
import { BlockMenuImage } from 'common/components/ContentEditor/elements/image/BlockMenuImage';
import { options } from 'common/components/ContentEditor/options';

import { IMenuPosition } from './types';

const BLOCK_MENUS = {
    [options.img.type]: BlockMenuImage,
    [options.file.type]: BlockMenuFile,
    [options.media_embed.type]: BlockMenuEmbed,
} as const;

export function getMenuPosition(
    editor: SlateEditor,
    menuRef: HTMLElement,
    element: Element
): IMenuPosition | undefined {
    const elementEl = ReactEditor.toDOMNode(
        asEditor(editor) as ReactEditor,
        element
    );

    const menuRect = menuRef.getBoundingClientRect();
    const elementRect = elementEl.getBoundingClientRect();

    const { width: menuWidth } = menuRect;
    const extraPadding = 10;

    const top = elementRect.top + window.pageYOffset;
    const left =
        elementRect.left + window.pageXOffset - (menuWidth + extraPadding);

    return { top, left };
}

export function getCurrentBlockMenu(element: Element) {
    if (!Element.isElement(element)) return null;

    const elementType = (element as unknown as { type: string }).type;

    return BLOCK_MENUS[elementType as keyof typeof BLOCK_MENUS] ?? null;
}
